// Global registration of the Base* components, formerly provided by the
// @addf/addf-vue-base-components package. Shared components are copies of
// Funeral Manager's src/components/addf-package; ./crema holds the
// Crema-only ones.
import ActivityTable from './crema/BaseActivityTable/ActivityTable.vue'
import BaseButton from './components/BaseButton/BaseButton.vue'
import BaseButtonInput from './components/BaseInput/BaseButtonInput.vue'
import BaseCardSection from './components/BaseCard/BaseCardSection.vue'
import BaseCheckBox from './components/BaseCheckBox/BaseCheckBox.vue'
import BaseContentTable from './components/BaseTable/BaseContentTable.vue'
import BaseDateInput from './components/BaseInput/BaseDateInput.vue'
import BaseEditLabel from './components/BaseLabel/BaseEditLabel.vue'
import BaseFileDropComponent from './crema/BaseFileDropComponent.vue'
import BaseRadioCards from './crema/BaseRadioCards.vue'
import BaseInput from './components/BaseInput/BaseInput.vue'
import BaseInputDynamicForm from './crema/DynamicForm/components/BaseInputDynamicForm.vue'
import BaseLabel from './components/BaseLabel/BaseLabel.vue'
import BaseMaskedInput from './components/BaseInput/BaseMaskedInput.vue'
import BasePageFull from './crema/BasePageFull.vue'
import BaseRadioGroup from './components/BaseRadioGroup/BaseRadioGroup.vue'
import BaseSearchInput from './components/BaseInput/BaseSearchInput.vue'
import BaseSelectMultiple from './crema/BaseSelectMultiple.vue'
import BaseSelectSimple from './crema/BaseSelectSimple.vue'
import BaseSelectSimpleAjax from './crema/BaseSelectSimpleAjax.vue'
import BaseShowEditDateInput from './components/BaseShowEditInput/BaseShowEditDateInput.vue'
import BaseShowEditDatePicker from './crema/BaseShowEditDatePicker.vue'
import BaseShowEditInput from './components/BaseShowEditInput/BaseShowEditInput.vue'
import BaseShowEditInputButton from './components/BaseShowEditInput/BaseShowEditInputButton.vue'
import BaseShowEditPriceInput from './components/BaseShowEditInput/BaseShowEditPriceInput.vue'
import BaseShowEditTranslation from './components/BaseShowEditInput/BaseShowEditTranslation.vue'
import BaseShowEditIsoDateTimeInput from './components/BaseShowEditInput/BaseShowEditIsoDateTimeInput.vue'
import BaseShowEditPhoneInput from './components/BaseShowEditInput/BaseShowEditPhoneInput.vue'
import BaseShowEditRadioGroup from './components/BaseShowEditRadioGroup/BaseShowEditRadioGroup.vue'
import BaseShowEditSelectAjax from './crema/BaseShowEditSelectAjax.vue'
import BaseShowEditSelectSimple from './crema/BaseShowEditSelectSimple.vue'
import BaseShowEditTextArea from './components/BaseShowEditInput/BaseShowEditTextArea.vue'
import BaseShowEditTimeInput from './components/BaseShowEditInput/BaseShowEditTimeInput.vue'
import BaseShowLabel from './components/BaseLabel/BaseShowLabel.vue'
import BaseShowPhoneLabel from './components/BaseLabel/BaseShowPhoneLabel.vue'
import BaseSimpleCard from './components/BaseCard/BaseSimpleCard.vue'
import BaseSimpleCheckboxGroup from './components/BaseCheckBox/BaseSimpleCheckboxGroup.vue'
import BaseSimpleDatePicker from './crema/BaseSimpleDatePicker.vue'
import BaseSimpleRadioGroup from './components/BaseRadioGroup/BaseSimpleRadioGroup.vue'
import BaseCenteredModal from './components/modal/BaseCenteredModal.vue'
import BaseSimpleShowEditCheckboxGroup from './components/BaseShowEditCheckBox/BaseSimpleShowEditCheckboxGroup.vue'
import BaseSimpleTab from './components/BaseTabs/BaseSimpleTab.vue'
import BaseSwitch from './components/BaseSwitch/BaseSwitch.vue'
import BaseTextArea from './components/BaseInput/BaseTextArea.vue'
import BaseThComponent from './components/BaseTable/BaseThComponent.vue'
import BaseThemeButton from './components/BaseButton/BaseThemeButton.vue'
import BaseTimeInput from './components/BaseInput/BaseTimeInput.vue'
import BaseTrueFalseShowEditRadioGroup from './components/BaseShowEditRadioGroup/BaseTrueFalseShowEditRadioGroup.vue'
import BaseWysiwyg from './components/Wysiwyg/BaseWysiwyg.vue'
import CheckboxWithInput from './components/BaseShowEditCheckBox/components/CheckboxWithInput.vue'
import ColumnVisibilityDropDownComponent from './crema/ColumnVisibilityDropDownComponent.vue'
import ContentTableCell from './components/BaseTable/ContentTableCell.vue'
import DropdownStatus from './components/DropdownFiles/DropdownStatus.vue'
import DropdownTaskStatusSquare from './components/DropdownFiles/DropdownTaskStatusSquare.vue'
import DropdownWorkStatus from './components/DropdownFiles/DropdownWorkStatus.vue'
import DynamicFormInput from './crema/DynamicForm/DynamicFormInput.vue'
import IFramePdf from './components/BaseIFramePDF/IFramePdf.vue'
import LabelWitchCheckBoxChecked from './components/BaseShowEditCheckBox/components/LabelWitchCheckBoxChecked.vue'
import SelectCustomer from './crema/SelectCustomer.vue'
import SelectUserSimple from './crema/SelectUserSimple.vue'
// Crema's settings panel (FM's TabContentFormComponent look), same slots.
import SettingsPageFull from './crema/SettingsPageFull.vue'
import BaseBooleanRadioGroup from './crema/BaseBooleanRadioGroup.vue'
import DropdownColoredStatus from './crema/DropdownFiles/DropdownColoredStatus.vue'
import BaseDateRangeInput from './crema/BaseDateRangeInput.vue'
import BaseDeleteButton from './crema/BaseDeleteButton.vue'
import BaseWorkPageLayout from './crema/BaseWorkPageLayout.vue'
import PageSection from '@c/PageSection.vue'
import BaseDropDownMenu from './components/dropdown/BaseDropDownMenu.vue'
import SelectAjax from '@c/SelectAjaxComponent/component/SelectAjax.vue'
import metadataSelects from './crema/metadataSelects'

const components = {
  ActivityTable,
  BaseButton,
  BaseButtonInput,
  BaseCardSection,
  BaseCheckBox,
  BaseContentTable,
  BaseDateInput,
  BaseEditLabel,
  BaseFileDropComponent,
  BaseRadioCards,
  BaseInput,
  BaseInputDynamicForm,
  BaseLabel,
  BaseMaskedInput,
  BasePageFull,
  BaseRadioGroup,
  BaseSearchInput,
  BaseSelectMultiple,
  BaseSelectSimple,
  BaseSelectSimpleAjax,
  BaseShowEditDateInput,
  BaseShowEditDatePicker,
  BaseShowEditInput,
  BaseShowEditInputButton,
  BaseShowEditPriceInput,
  BaseShowEditTranslation,
  BaseShowEditIsoDateTimeInput,
  BaseShowEditPhoneInput,
  BaseShowEditRadioGroup,
  BaseShowEditSelectAjax,
  BaseShowEditSelectSimple,
  BaseShowEditTextArea,
  BaseShowEditTimeInput,
  BaseShowLabel,
  BaseShowPhoneLabel,
  BaseSimpleCard,
  BaseSimpleCheckboxGroup,
  BaseSimpleDatePicker,
  BaseSimpleRadioGroup,
  BaseDeleteButton,
  BaseCenteredModal,
  BaseSimpleShowEditCheckboxGroup,
  BaseSimpleTab,
  BaseSwitch,
  BaseTextArea,
  BaseThComponent,
  BaseThemeButton,
  BaseTimeInput,
  BaseTrueFalseShowEditRadioGroup,
  BaseWysiwyg,
  CheckboxWithInput,
  ColumnVisibilityDropDownComponent,
  ContentTableCell,
  DropdownStatus,
  DropdownTaskStatusSquare,
  DropdownWorkStatus,
  DynamicFormInput,
  IFramePdf,
  LabelWitchCheckBoxChecked,
  SelectCustomer,
  SelectUserSimple,
  SettingsPageFull,
  BaseBooleanRadioGroup,
  DropdownColoredStatus,
  BaseDateRangeInput,
  BaseWorkPageLayout,
  PageSection,
  BaseDropDownMenu,
  SelectAjax,
  ...metadataSelects
}

export default (app) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
